module.exports = __webpack_public_path__ + "static/Canela-Thin-324a3a6a13d85b87cbd052731d2667af.otf";